// @ts-nocheck
import {Form as BSForm} from 'react-bootstrap'
import Input from './Input'
import Textarea from './Textarea'
import BuiltInSelect from './BuiltInSelect'
import AdvancedSelect from './advancedSelect/AdvancedSelect'
import Check from './Check'
import PhoneNumberInput from './PhoneNumberInput'
import {ReactNode} from 'react'
// import Tags from './Tags';
// import SelectWithAdd from './SelectWithAdd';
// import Time from './Time';
// import AsyncAdvancedSelect from './AsyncAdvancedSelect';
// import CreatableSelect from './CreatableSelect';

type FormikControlProps = {
  control: 'input' | 'phone-input' | 'textarea' | 'select' | 'select-advanced' | 'check'
  showInlineError?: boolean
  children?: ReactNode
  [key: string]: any
}

const FormikControl: React.FC<FormikControlProps> = ({
  control,
  showInlineError = true,
  children = null,
  ...rest
}) => {
  switch (control) {
    case 'input':
      return (
        <Input
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )
    case 'phone-input':
      return (
        <PhoneNumberInput
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )

    case 'textarea':
      return (
        <Textarea
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )
    case 'select':
      return (
        <BuiltInSelect
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        >
          {children}
        </BuiltInSelect>
      )
    case 'select-advanced':
      return (
        <AdvancedSelect
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )
    // case 'creatable-select':
    //   return (
    //     <CreatableSelect {...rest} ErrorFeedback={showInlineError ? ErrorFeedback: null} validityClass={validityClass} />
    //   )
    // case 'async-select':
    //   return (
    //     <AsyncAdvancedSelect
    //       {...rest}
    //       ErrorFeedback={showInlineError ? ErrorFeedback: null}
    //       validityClass={validityClass}
    //     />
    //   )
    // case 'select-add':
    //   return (
    //     <SelectWithAdd
    //       {...rest}
    //       ErrorFeedback={showInlineError ? ErrorFeedback: null}
    //       validityClass={validityClass}
    //     />
    //   )
    case 'check':
      return (
        <Check
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )
    // case 'tags':
    //   return (
    //     <Tags
    //       {...rest}
    //       ErrorFeedback={showInlineError ? ErrorFeedback: null}
    //       validityClass={validityClass}
    //     />
    //   )
    // case 'time':
    //   return (
    //     <Time
    //       {...rest}
    //       ErrorFeedback={showInlineError ? ErrorFeedback: null}
    //       validityClass={validityClass}
    //     />
    //   )

    default:
      return (
        <Input
          {...rest}
          ErrorFeedback={showInlineError ? ErrorFeedback : null}
          validityClass={validityClass}
        />
      )
  }
}

const validityClass = (error, value, touched) => {
  if (!error && value === 0) {
    return 'text-success'
  }
  if (!touched && !value) {
    return 'text-danger'
  }
  if (!!error || !value) {
    return 'text-danger'
  } else {
    return 'text-success'
  }
}
export const ErrorFeedback: React.FC = ({children}) => (
  <BSForm.Control.Feedback
    type="invalid"
    style={{top: 'auto', left: 'auto'}}
    className="bg-white text-danger d-block py-0 mt--0 px-0"
    tooltip
  >
    {children}
  </BSForm.Control.Feedback>
)
export default FormikControl
